import React, { useCallback } from 'react';
import { Badge, Tabs } from 'antd';
import PropTypes from 'prop-types';

import EquipmentUsageTab from './EquipmentUsageTab';

import { PROPERTY_MAP } from './equipment.constants';

import {
  didExceedHoursWarning,
  didExceedMileageWarning,
} from './equipment.helpers';

import colors from '../constants/Colors';

const { TabPane } = Tabs;

export default function EquipmentUsage({
  id,
  currentEquipment,
}) {
  const TabComponent = useCallback((title, isMileage) => {
    const {
      thresholdEmailProperty,
      nearThresholdProperty,
      thresholdProperty,
      currentProperty,
    } = PROPERTY_MAP[isMileage ? 'mileage' : 'hours'];

    const warnFunc = isMileage ? didExceedMileageWarning : didExceedHoursWarning;

    const hasExceeded = !!currentEquipment?.[thresholdEmailProperty];
    const shouldWarn = warnFunc({
      [nearThresholdProperty]: currentEquipment?.[nearThresholdProperty],
      [thresholdProperty]: currentEquipment?.[thresholdProperty],
      [currentProperty]: currentEquipment?.[currentProperty],
    });

    if (!hasExceeded && !shouldWarn) {
      return title;
    }

    const color = hasExceeded ? 'red' : colors.YELLOW_500;

    return (
      <div style={{ paddingRight: 6 }}>
        <Badge
          dot
          offset={[2, 0]}
          color={color}
        >
          <span>{title}</span>
        </Badge>
      </div>
    );
  }, [currentEquipment]);

  return (
    <Tabs
      tabPosition="left"
      destroyInactiveTabPane
    >
      <TabPane
        key="hours"
        tab={TabComponent('Hours', false)}
      >
        <EquipmentUsageTab equipmentId={id} />
      </TabPane>
      <TabPane
        key="mileage"
        tab={TabComponent('Mileage', true)}
      >
        <EquipmentUsageTab equipmentId={id} isMileage />
      </TabPane>
    </Tabs>
  );
}

EquipmentUsage.propTypes = {
  id: PropTypes.string.isRequired,
  currentEquipment: PropTypes.shape({
    thresholdEmailSent: PropTypes.bool,
    thresholdMileageEmailSent: PropTypes.bool,
  }).isRequired,
};
